import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
} from '@angular/core'
import { DentistService } from 'src/app/core/services/dentist.service'
import { isPlatformBrowser } from '@angular/common'

@Component({
    selector: 'app-modal-options-dentist-select-cards',
    templateUrl: './modal-options-dentist-select-cards.component.html',
    styleUrls: ['./modal-options-dentist-select-cards.component.scss'],
    standalone: false
})
export class ModalOptionsDentistSelectCardsComponent implements OnInit {
  showCertifiedPopup: boolean = false
  // dentistListInfo
  selectedCardNumber
  loadedNumber = 20
  unlistener
  constructor(private _dentist: DentistService, private renderer2: Renderer2, @Inject(PLATFORM_ID) private platformId: object) {}
  @Output() selectedDentist: EventEmitter<any> = new EventEmitter()
  @Output() loadMore: EventEmitter<number> = new EventEmitter()
  @Input() dentistListInfo
  @ViewChild('dentistScroll') dentScroll: ElementRef

  ngOnInit(): void {
    // this.dentistListInfo = this._dentist.dentistListdata.data
  }
  ngOnChanges() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.renderer2
    // console.log(this.dentScroll)
    // console.log(this.dentistListInfo)
    setTimeout(() => {
      let dentScroll: any = document.getElementById('dentistScroll')
      let dentElem: any = document.getElementsByClassName('profile_section')
      if (this.dentistListInfo.data.totalCount > this.loadedNumber) {
        this.unlistener = this.renderer2.listen(dentScroll, 'scroll', (event) => {
          // dentScroll.addEventListener('scroll', (event) => {
            // console.log(event, event.target.scrollTop, event.target.clientHeight, event.target.scrollHeight)
            // console.log()
            if (
              event.target.scrollTop >
              event.target.scrollHeight - event.target.clientHeight - dentElem[0].clientHeight
            ) {
              this.loadMore.emit(this.loadedNumber)
              this.loadedNumber += 20
              // console.log(event)
              // event.target.removeEventListener()
              this.unlistener();
              // dentScroll.replaceWith(dentScroll.cloneNode(true))
            }
          // }
          // )
        })
      }
      // if(this.dentistListInfo.data.totalCount > this.loadedNumber) {
      // dentScroll.addEventListener('scroll', (event) => {
      //   // console.log(event, event.target.scrollTop, event.target.clientHeight, event.target.scrollHeight)
      //   // console.log()
      //   if(event.target.scrollTop > event.target.scrollHeight - event.target.clientHeight - dentElem[0].clientHeight){
      //     this.loadMore.emit(this.loadedNumber)
      //     this.loadedNumber += 20
      //     // console.log(event)
      //     // event.target.removeEventListener()

      //     dentScroll.replaceWith(dentScroll.cloneNode(true));
      //   }
      // })}
    }, 500)
  }

  onPopupClosed() {
    this.showCertifiedPopup = false
  }
  onPopupOpen() {
    this.showCertifiedPopup = true
  }
  clickDentist(i) {
    this.selectedCardNumber = i
    this.selectedDentist.emit(this.dentistListInfo.data.providers[this.selectedCardNumber])
  }
  distance(dist) {
    // let lat2 = this._dentist.userCoords.lat
    // let lon2 = this._dentist.userCoords.long
    // if ((lat1 == lat2) && (lon1 == lon2)) {
    //   return 0;
    // }
    // else {
    //   let radlat1 = Math.PI * lat1/180;
    //   let radlat2 = Math.PI * lat2/180;
    //   let theta = lon1-lon2;
    //   let radtheta = Math.PI * theta/180;
    //   let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    //   if (dist > 1) {
    //     dist = 1;
    //   }
    //   dist = Math.acos(dist);
    //   dist = dist * 180/Math.PI;
    //   dist = Math.round(dist * 60 * 1.1515 * 10) / 10;
    // if (unit=="K") { dist = dist * 1.609344 }
    // if (unit=="N") { dist = dist * 0.8684 }
    return Math.round(+dist * 10) / 10
  }
  // }
}
